import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

type PageHeroProps = {
  label: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  breadcrumb: string;
};

export default function PageHero({
  label,
  title,
  description,
  image,
  imageAlt,
  breadcrumb,
}: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950 pb-16 pt-36 md:pb-20 md:pt-44">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={imageAlt}
          title={`${breadcrumb} — SGSCTIC`}
          className="hero-zoom h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-foreground-950/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/20 to-transparent" />
        <div className="absolute inset-0 hatch-lines-light opacity-15" />
      </div>

      <div className="container-wide relative z-10">
        <Reveal>
          <nav className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-background-400">
            <Link to="/" className="transition-colors hover:text-accent-400">
              Accueil
            </Link>
            <i className="ri-arrow-right-s-line text-accent-500" />
            <span className="text-background-200">{breadcrumb}</span>
          </nav>
          <div className="mt-6 flex items-center gap-3">
            <span className="h-px w-8 bg-accent-500" />
            <span className="label-mono text-accent-400">{label}</span>
          </div>
          <h1 className="display-title mt-5 max-w-4xl text-5xl leading-[0.92] text-background-50 sm:text-6xl lg:text-7xl">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            {description}
          </p>
        </Reveal>
      </div>
    </section>
  );
}